import { CryptJsSettingsInAutoAct } from "../../constant/crypt-js-settings";
import { CryptJsManager } from "../share/crypt-js/crypt-js-manager";
import { UtilString } from "../share/util/utilString";
import { AutoActService } from "./auto-act.service";

/** （D)いただきます端末操作の未処理アクションを取得し、実行する */
export class ItadakimasuOpe {
  private http: AutoActService;

  constructor(autoActService: AutoActService) {
    this.http = autoActService;
  }

  public checkReadyActionAsync() {
    let smile9IdWithPrefix = localStorage.getItem('[AutoAct]Smile9ID');
    if (!smile9IdWithPrefix || smile9IdWithPrefix === '') {
      return false;
    }
    // localStorageのSmile9IDを復号して利用
    smile9IdWithPrefix = CryptJsManager.decrypt(smile9IdWithPrefix, CryptJsSettingsInAutoAct.KEY, CryptJsSettingsInAutoAct.IV);

    this.http.checkItadakimasuOpe({smile9Id: smile9IdWithPrefix, ug_id: localStorage.getItem('[AutoAct]ugId')})
      .then(result => {
        if (!UtilString.isNullOrUndefinedOrWhiteSpace(result.action)) {
          this.doAction(result.action);
        }
      })
      .catch(err => console.error(err));
    return true;
  }

  private doAction(readyAction: string): boolean {
    switch (readyAction) {
      case 'hard_reload':
        location.reload();
        return true;
      default:
        console.error(`${readyAction} is unknown action.`);
        return false;
    }
  }
}
